import _sfc_main from "./SwitchMirror.vue2.mjs";
/* empty css                   */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "mirror-icon" }, [_c(_setup.SvgIcon, { directives: [{ name: "tap", rawName: "v-tap", value: _setup.toogleMirrorStatus, expression: "toogleMirrorStatus" }], attrs: { "icon": _setup.MirrorIcon, "custom-style": { backgroundSize: "50%" } } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c70cf590"
);
const SwitchMirror = __component__.exports;
export {
  SwitchMirror as default
};
